// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface IPrefundReturnApproveDto
 */
export interface IPrefundReturnApproveDto {
    /**
     * 
     * @type {number}
     * @memberof IPrefundReturnApproveDto
     */
    invoice_id: number;
    /**
     * 
     * @type {number}
     * @memberof IPrefundReturnApproveDto
     */
    invoice_amount: number;
}

/**
 * Check if a given object implements the IPrefundReturnApproveDto interface.
 */
export function instanceOfIPrefundReturnApproveDto(value: object): value is IPrefundReturnApproveDto {
    if (!('invoice_id' in value) || value['invoice_id'] === undefined) return false;
    if (!('invoice_amount' in value) || value['invoice_amount'] === undefined) return false;
    return true;
}

export function IPrefundReturnApproveDtoFromJSON(json: any): IPrefundReturnApproveDto {
    return IPrefundReturnApproveDtoFromJSONTyped(json, false);
}

export function IPrefundReturnApproveDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IPrefundReturnApproveDto {
    if (json == null) {
        return json;
    }
    return {
        
        'invoice_id': json['invoice_id'],
        'invoice_amount': json['invoice_amount'],
    };
}

export function IPrefundReturnApproveDtoToJSON(json: any): IPrefundReturnApproveDto {
    return IPrefundReturnApproveDtoToJSONTyped(json, false);
}

export function IPrefundReturnApproveDtoToJSONTyped(value?: IPrefundReturnApproveDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'invoice_id': value['invoice_id'],
        'invoice_amount': value['invoice_amount'],
    };
}

